import React, { useEffect } from 'react';
import event9 from './eventImg/event-18.webp';

const Event19 = () => {
  useEffect(() => {
    document.title = "REFCON";
  }, []);

  // Generate array of 24 image paths
  const totalPages = 4;
  const pageImages = Array.from({ length: totalPages }, (_, i) => 
    require(`./eventImg/pdf/event-22-aug-${i + 1}.webp`)
  );

  return (
    <>
      <div className='eventheading'>
        <h1 className='text-center'>22 August 2025</h1>
        <h3 className='text-center'>REFCON</h3>
      </div>

      <div className='container' id='calanderevent'>
        {/* <img
          src={event9}
          alt='South Asia’s Premier Refrigeration & Cold-Chain Exhibition'
          style={{ maxWidth: '100%', height: 'auto', marginBottom: '20px' }}
        /> */}

        {/* <button className='mb-4'>
          <a
            href='https://us02web.zoom.us/webinar/register/WN_zAoc_KkmQgOOOLaKWDqM-Q#/registration'
            target='_blank'
            rel='noopener noreferrer'
          >
            Register Now
          </a>
        </button> */}

        {/* Show all pages (webp images) */}
        <div className="pdf-pages d-flex justify-content-center align-items-center flex-column" style={{ marginTop: '30px' }}>
  {pageImages.map((img, idx) => (
    <img
      key={idx}
      src={img}
      alt={`Page ${idx + 1}`}
      style={{
        width: '100%',
        maxWidth: '800px', // Limit size on large screens
        margin: '0 auto 20px auto',
        display: 'block',
        border: '1px solid #ccc',
        borderRadius: '8px',
      }}
    />
  ))}
  {/* <button className='mb-4'>
          <a
            href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/bkslsWEIoY7aG6A='
            target='_blank'
            rel='noopener noreferrer'
          >
            Register Now
          </a>
        </button> */}
</div>

      </div>
    </>
  );
};

export default Event19;
